import { api_set_flash_message_path } from '@routes';

import request from './request';

export interface FlashMessageParams {
  type: 'alert' | 'error' | 'message' | 'notice';
  message: string;
}

export async function setFlashMessage(params: FlashMessageParams) {
  const resp = await request('get', api_set_flash_message_path(params));
  return resp;
}
